import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconCopyContent(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7 4C7 2.89543 7.89543 2 9 2H15C16.1046 2 17 2.89543 17 4H18C19.1046 4 20 4.89543 20 6V20C20 21.1046 19.1046 22 18 22H6C4.89543 22 4 21.1046 4 20V6C4 4.89543 4.89543 4 6 4L7 4ZM9 4V6H15V4H9ZM17 6C17 7.10457 16.1046 8 15 8H9C7.89543 8 7 7.10457 7 6H6V20H18V6H17Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
